export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/health_medical.b302e18.svg";